import { Component, OnInit } from '@angular/core';
import { CockpitService } from '../../../service/cockpit/cockpit.service';
import { SummaryTableItem } from '../summary-table/summary-table.component';

@Component({
  selector: 'app-analysis-summary',
  templateUrl: './analysis-summary.component.html'
})
export class AnalysisSummaryComponent implements OnInit {

  public analysisSummaryItems: SummaryTableItem[] = [];

  constructor(private cockpitService: CockpitService) { }

  ngOnInit() {
    this.getApprovalSummaryItems();
  }

  getApprovalSummaryItems(gcs: string[] = []) {
    this.cockpitService.getAnalysisSummary(gcs).subscribe(result => {
			if (result.Success) {
				this.analysisSummaryItems = result.Result;
			}
		}, error => {
			console.log(error);
		});
  }
}



// WEBPACK FOOTER //
// ./src/app/cockpit/component/cockpit/analysis-summary/analysis-summary.component.ts